import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { markWithdrawRequestSettled } from '../withdrawRequestsEndpoints'
import { withdrawRequestKeys } from '../withdrawRequestsQueryKeys'
import type { MarkSettledWithdrawRequestInput } from '../../types/withdrawRequestsTypes'

export function useMarkSettledWithdrawRequestMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: MarkSettledWithdrawRequestInput) => markWithdrawRequestSettled(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.lists() })
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.statusCounts() })
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.detail(vars.id) })
    },
  })
}
